import React from 'react'
import { Box, Grid, Typography } from "@mui/material";
import Chart from 'react-apexcharts';

function BarChartAccumulativeTable(props) {

  return (
    <>
        <Box width="140%" mb={-7} ml={3} style={{ position: "relative", top: "-40px" }}>
            <Chart
                options={{
                    chart: {
                      type: 'bar',
                      stacked: 'true',
                      toolbar: {
                        show: false
                      },
                      zoom: {
                        enabled: false
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: true,
                      }
                    },
                    colors: props.status === 'Running' ? ['#00E396', '#fff9c4'] : ['#00E396', '#e0e0e0'],
                    dataLabels: {
                      enabled: true,
                      textAnchor: 'middle',
                      style: {
                        colors: ['#616161']
                      },
                      formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                        if (seriesIndex === 0) {
                          return value
                        }
                      },
                      offsetX: 0,
                      dropShadow: {
                        enabled: false
                      },
                      distributed: true,
                      offsetX: 0,
                      offsetY: 0,
                      total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                          fontSize: '13px',
                          fontWeight: 900,
                          alignItems: 'left'
                        }
                      }
                    },
                    legend: {
                      show: false,
                      showForSingleSeries: true,
                      customLegendItems: ['Actual', 'Expected'],
                      markers: {
                        fillColors: ['#00E396', '#775DD0']
                      }
                    },
                    tooltip: {
                      enabled: false,
                    },
                    xaxis: {
                      type: 'category',
                      categories: [], type: 'category',
                      categories: [],
                      range: props.target,
                      min: 0,
                      max: props.target > props.actual_output ? props.target : props.actual_output,
                      show: false,
                      labels: {
                        show: false
                      },
                      axisBorder: {
                        show: false
                      },
                      axisTicks: {
                        show: false
                      },
                    },
                    yaxis: {
                      axisBorder: {
                        show: false
                      },
                      axisTicks: {
                        show: false,
                      },
                      labels: {
                        show: false,
                      },
                    },
                    grid: {
                      padding: {
                        left: -16
                      }
                    },
                    
                  }}

                  series={[
                    {
                      name: 'Actual',
                      data: [props.actual_output]
                    },
                    {
                      name: 'Waiting',
                      data: [props.target - props.actual_output < 0 ? 0 : props.target - props.actual_output]
                    }
                  ]}
                type='bar'
                width={props.width}
                height={props.height}
            />
        </Box>
        <Box width="100%" ml={3} mr={3}>
            <Grid container>
            <Grid item xs={6}>
                <Typography color='#000000' fontSize={'14px'} align='left'>
                Target {(props.target).toLocaleString()} {props.unit}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                
            </Grid>
            </Grid>
        </Box>
    </>
  )
}

BarChartAccumulativeTable.propTypes = {}

export default BarChartAccumulativeTable
